<template>
  <div class="edit-link-box">
    <el-dialog
      :title="this.params.parent+ ' 下级代理'"
      :visible.sync="dialogVisible"
      top="1%"
      width="1400px"
      :before-close="handleClose"
      :close-on-click-modal="false"
      class="el-dialogs"
    >
      <!--操作栏-->
      <div class="action-bar">
        <el-input
          placeholder="商区码"
          size="small"
          @clear="getDistrictList"
          class="param-input"
          v-model="params.districtCode"
          @change="getDistrictList()"
          clearable
        ></el-input>
        <el-input
          placeholder="用户名"
          size="small"
          @clear="getDistrictList"
          class="param-input"
          v-model.number="params.name"
          @change="getDistrictList()"
          clearable
        ></el-input>
        <el-input
          placeholder="手机号码"
          size="small"
          @clear="getDistrictList"
          class="param-input"
          v-model="params.mobile"
          @change="getDistrictList()"
          clearable
        ></el-input>
        <el-button type="primary" size="small" @click="getDistrictList()">搜索</el-button>
        <el-button type="primary" size="small" @click="addSubDistrict">添加</el-button>
      </div>
      <!-- 表格数据 -->
      <el-table
        :data="tableData"
        style="width: 100%"
        border
        ref="multipleTable"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        height="620"
      >
        <el-table-column prop="districtCode" label="商区码" align="center" min-width="120" fixed>
          <template slot-scope="scope">
            <span>{{ scope.row.districtCode }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="parent" label="上级商区" align="center" min-width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.parent }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="discType" label="商区类型" align="center" min-width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.discType | handleFilterDiscType }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="用户名" align="center" min-width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="mobile" label="手机号码" align="center" min-width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.mobile }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="password" label="用户密码" align="center" min-width="120">
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="top">
              <p>{{ scope.row.password }}</p>
              <div slot="reference" class="name-wrapper">
                <el-tag type="info" size="medium">查看密码</el-tag>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          prop="inviteLink"
          label="邀请链接"
          align="center"
          show-overflow-tooltip
          min-width="120"
        >
          <template slot-scope="scope">
            <!-- <span>{{scope.row.inviteLink || '未知'}}</span> -->
            <el-button type="primary" @click="showLink(scope.row)" size="mini">查看推广链接</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="balance" label="余额/元" align="center" min-width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.balance || "无" }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" align="center" min-width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.remark || "无" }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createdAt" label="添加时间" align="center" min-width="160">
          <template slot-scope="scope">
            <span>{{ scope.row.createdAt | changeDate }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="disable" label="启用商区" align="center" min-width="100">
          <template slot-scope="scope">
            <span>
              <el-switch
                :value="!scope.row.disable"
                active-color="#13ce66"
                inactive-color="#666666"
                :active-text="!scope.row.disable ? '是' : '否'"
                disabled
              ></el-switch>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="lock" label="允许登陆" align="center" min-width="100">
          <template slot-scope="scope">
            <span>
              <el-switch
                :value="!scope.row.lock"
                active-color="#13ce66"
                inactive-color="#666666"
                :active-text="!scope.row.lock ? '是' : '否'"
                disabled
              ></el-switch>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="disTrans" label="允许提现" align="center" min-width="100">
          <template slot-scope="scope">
            <span>
              <el-switch
                :value="!scope.row.disTrans"
                active-color="#13ce66"
                inactive-color="#666666"
                :active-text="!scope.row.disTrans ? '是' : '否'"
                disabled
              ></el-switch>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="deductType" label="扣量方式" align="center" min-width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.deductType | deductionType }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="nuDeductionRatio" label="用户扣量比例" align="center" min-width="120">
          <template slot-scope="scope">
            <span>{{ (scope.row.nuDeductionRatio*100).toFixed(2) || "0" }}%</span>
          </template>
        </el-table-column>
        <el-table-column prop="deductionRatio" label="消费扣量比例" align="center" min-width="120">
          <template slot-scope="scope">
            <span>{{ (scope.row.deductionRatio*100).toFixed(2) || "0" }}%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="operating"
          fixed="right"
          label="操作"
          type="flex"
          justify="end"
          min-width="340"
        >
          <template slot-scope="scope">
            <div style="operating">
              <div style="margin-bottom:5px">
                <el-button
                  type="success"
                  size="mini"
                  icon="el-icon-edit"
                  @click="editDistrict(scope.row)"
                >编 辑</el-button>
                <el-button
                  :type="scope.row.disable ? 'success' : 'danger'"
                  size="mini"
                  @click="ban(scope.row)"
                >{{ scope.row.disable ? "启 用" : "禁 用" }}</el-button>
                <el-button
                  class="flex-item"
                  type="danger"
                  size="mini"
                  icon="el-icon-delete"
                  @click="remove(scope.row.id)"
                >删 除</el-button>
                <el-button size="mini" @click="rechage(scope.row)">充值记录</el-button>
              </div>
              <div>
                <el-button size="mini" @click="statDialy(scope.row)">每日统计</el-button>
                <el-button size="mini" @click="payVIPHis(scope.row)">购买记录</el-button>
                <el-button size="mini" @click="widthdraw(scope.row)">提现记录</el-button>
                <el-button size="mini" @click="statSettlement(scope.row)">结算账单</el-button>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!--分页组件-->
      <el-pagination
        :page-sizes="[10, 15, 20, 30]"
        :current-page="params.pageNumber"
        :page-size="params.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
        v-if="total > 10"
        @size-change="changeSize"
        @current-change="changeCurrent"
      ></el-pagination>
      <div class="zw"></div>
    </el-dialog>
    <!--编辑tag弹窗-->
    <edit-district ref="editDistrict" @handlerDistrictList="getDistrictList"></edit-district>
    <!--新增tag弹窗-->
    <add-sub-district ref="addSubDistrict" @handlerAddDistrict="getDistrictList()"></add-sub-district>
    <rechage-popup ref="rechage"></rechage-popup>
    <widthdraw-popup ref="widthdraw"></widthdraw-popup>
    <!--查看分享链接-->
    <link-popup ref="linkPopup"></link-popup>
    <PayHisPopup ref="payHisPopup"></PayHisPopup>
    <StatDialy ref="statDialy"></StatDialy>
    <StatSettlement ref="statSettlement"></StatSettlement>
  </div>
</template>
<script>
import editDistrict from "./editPage/editDistrict";
import AddSubDistrict from "./addSubDistrict";
import RechagePopup from "./rechagePopup";
import WidthdrawPopup from "./widthdrawPopup";
import LinkPopup from "./linkPopup";
import PayHisPopup from "./payHisPopup";
import StatDialy from "./statDialy";
import StatSettlement from "./statSettlement";
import API from "@/api";
export default {
  data() {
    return {
      // 外层弹出框
      dialogVisible: false,
      // 列表数据
      text: "",
      loading: false,
      total: 0,
      tableData: [],
      params: {
        pageNumber: 1,
        pageSize: 10,
        parent: "",
        districtCode: "",
        name: "",
        // showChild: 1,
      },
    };
  },
  filters: {
    handleFilterDiscType(params) {
      if (params === undefined || params === "") {
        return;
      }
      switch (params) {
        case 0:
          return "CPS";
        case 1:
          return "CPA";
      }
    },
    deductionType(params) {
      if (params === undefined || params === "") {
        return;
      }
      switch (params) {
        case 0:
          return "不扣量";
        case 1:
          return "扣消费";
        case 2:
          return "扣用户";
        case 3:
          return "扣消费和用户";
      }
    },
  },
  components: {
    editDistrict,
    AddSubDistrict,
    RechagePopup,
    WidthdrawPopup,
    LinkPopup,
    PayHisPopup,
    StatDialy,
    StatSettlement,
  },
  methods: {
    // 获取商区代理列表
    getDistrictList(type) {
      this.loading = true;
      if (type === "status") {
        this.params.pageNumber = 1;
      }
      API.getDistrictList(this.params)
        .then((res) => {
          if (res.code === 200 && res.data.list) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          } else {
            this.tableData = [];
            this.total = 0;
          }
          this.loading = false;
        })
        .catch(() => {
          this.tableData = [];
          this.loading = false;
        });
    },
    // pageSize发生变化触发
    changeSize(size) {
      this.params.pageSize = size;
      this.params.pageNumber = 1;
      this.getDistrictList();
    },
    // 当前页发生变化触发
    changeCurrent(pageNumber) {
      this.params.pageNumber = pageNumber;
      this.getDistrictList();
    },
    // 禁用商区代理
    ban(row) {
      let params = { id: row.id, enable: row.disable };
      let t = row.disable ? "启用" : "禁用";
      let sucMsg = {
        message:
          "[商区: " + row.districtCode + "] " + t + "登陆、提现、结算功能成功",
        type: "success",
      };
      this.$confirm(
        "您确定要" + t + "当前代理的登陆、提现、结算功能吗？",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          API.disDistrict(params).then((res) => {
            if (res.code === 200) {
              this.$message(sucMsg);
            } else {
              if (res.tip) {
                this.$message.error(this.tip);
              } else {
                this.$message.error("操作失败！");
              }
            }
            this.getDistrictList();
          });
        })
        .catch(() => {});
    },
    // 删除
    remove(id) {
      this.$confirm("您确定要删除这条商区信息吗？", "删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          API.delDistrict({ id: id }).then((res) => {
            if (res.code === 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.getDistrictList();
            } else {
              if (res.tip) {
                this.$message.error(res.tip);
              } else {
                this.$message.error("删除失败");
              }
            }
          });
        })
        .catch(() => {});
    },
    //修改商区代理
    editDistrict(data) {
      this.$refs.editDistrict.open(data);
    },
    // 新增商区代理
    addSubDistrict() {
      this.$refs.addSubDistrict.open(this.params.parent);
    },
    // 查看上去代理充值列表
    rechage(row) {
      this.$refs.rechage.open(row);
    },
    // widthdraw
    widthdraw(row) {
      this.$refs.widthdraw.open(row);
    },
    // 查看邀请链接
    showLink(row) {
      this.$refs.linkPopup.open(row);
    },
    payVIPHis(row) {
      this.$refs.payHisPopup.open(row);
    },
    statDialy(row) {
      this.$refs.statDialy.open(row);
    },
    statSettlement(row) {
      this.$refs.statSettlement.open(row);
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.params = {
        pageNumber: 1,
        pageSize: 10,
        id: "", //流水id
        billType: "", //用户UID
        startTime: "",
        endTime: "",
        discCode: "", //商区码
      };
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(row) {
      this.dialogVisible = true;
      this.params.parent = row.districtCode;
      this.getDistrictList("status");
    },
  },
};
</script>
<style lang="scss" scoped>
.operating {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
}
</style>

<style lang="scss"></style>
